import React from "react";

import { useSelector } from "react-redux";
import { Route, Switch, useHistory } from "react-router-dom";

import NavbarAdmin from "./navbar/NavbarAdmin";
import Auth from "../utils/Auth";
import Notifier from "./common/tools/Notifier";
// import LiveBanner from "./liveBanner/LiveBanner";
import LiveBanner from "./liveBanner/LiveBanner";
import FastMenu from "./menu/FastMenu";
import MainMenu from "./menu/MainMenu";
import ProjectMenu from "./menu/ProjectMenu";
import {
  FAST_CHANNELS_ROUTE,
  PROJECTS_ROUTE,
  SIGNUP_ROUTE,
} from "./routes/routes";

import type { JSX, ReactNode } from "react";

import type { AppState } from "../reducers";

interface IAppLayout {
  children: ReactNode;
}

function MainLayout({ children }: IAppLayout): JSX.Element | null {
  const history = useHistory();
  const isLoggedIn = useSelector(
    (state: AppState) => state.loginReducer.isLoggedIn,
  );
  const isEditorAuth = useSelector(
    (state: AppState) => state.loginReducer.isEditorAuth,
  );

  const isEditorAuthorized = Auth.editorAuth() && isEditorAuth;

  if (isLoggedIn && !isEditorAuthorized) {
    history.push(SIGNUP_ROUTE);
    return null;
  }

  return (
    <div className="app-container app-admin-container">
      <LiveBanner />
      <NavbarAdmin />
      <div className="app-content">
        <div className="app-editor-content" id="app-editor-content">
          <Notifier />
          <Switch>
            <Route
              component={FastMenu}
              path={`${FAST_CHANNELS_ROUTE}/:channelId`}
            />
            <Route
              path={`${PROJECTS_ROUTE}/:projectSlug`}
              render={({ match }): JSX.Element => {
                if (match.params.projectSlug === "new") return <MainMenu />;
                return <ProjectMenu />;
              }}
            />
            <Route component={MainMenu} />
          </Switch>
          {children}
        </div>
      </div>
    </div>
  );
}

export default MainLayout;
